<template>
  <div class="page flex-col" :data-title="textTitle">
<!--    <div class="section_1 flex-row">-->
<!--      <span class="text_8">9:41</span>-->
<!--      <img-->
<!--        class="thumbnail_7"-->
<!--        referrerpolicy="no-referrer"-->
<!--        src="./assets/img/SketchPng1be20f0eced1f466b6b4dc3a981fc6b52a4b9cf391debed94bcf2e01f7c38668.png"-->
<!--       alt=""/>-->
<!--      <img-->
<!--        class="thumbnail_8"-->
<!--        referrerpolicy="no-referrer"-->
<!--        src="./assets/img/SketchPngb3bbe96fea0140cfc24043ebc96677b3c6566f6cd0b99cb137439fb58271c764.png"-->
<!--       alt=""/>-->
<!--      <img-->
<!--        class="image_5"-->
<!--        referrerpolicy="no-referrer"-->
<!--        src="./assets/img/SketchPng665b3244c48d10ac9e8386b5cde29cfdb79b140fafc91d556654d25871be90b5.png"-->
<!--       alt=""/>-->
<!--    </div>-->
    <div class="block_1 flex-col">
<!--      <div class="box_1 flex-row justify-between">-->
<!--        <img-->
<!--          class="thumbnail_9"-->
<!--          referrerpolicy="no-referrer"-->
<!--          src="./assets/img/e5433980ca6e4f79bbe5c51456824fc0_mergeImage.png"-->
<!--         alt=""/>-->
<!--        <span class="text_2">中宝AI药师</span>-->
<!--        <img-->
<!--          class="thumbnail_10"-->
<!--          referrerpolicy="no-referrer"-->
<!--          src="./assets/img/dfdf6ff606424c20a3b32aa38fb075d1_mergeImage.png"-->
<!--         alt=""/>-->
<!--      </div>-->
      <div class="box_2 flex-col">
        <div class="section_4 flex-row">
          <div class="image-text_2 flex-row justify-between">
            <div class="section_3 flex-col"></div>
            <span class="text-group_1">中宝AI药师</span>
          </div>

          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngac09b0ce88e8bd1b342e514ee6103752c38cf74774c6395e661f3d3ee81f74d7.png"
           alt="">
<!--          <img-->
<!--              class="image_2"-->
<!--              referrerpolicy="no-referrer"-->
<!--              src=""-->
<!--              alt="">-->
          <img  @click="share"
            class="thumbnail_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng2134ca67ec4c7707544b6da05e28654e7909a73e8f24721882da3bede9901df9.png"
           alt=""
                data-clipboard-action="copy" :data-clipboard-text= "pharm_url"
          />
        </div>
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPnga89f1580a969f255ce32b8fd523a5d5a2be9d432aa1e4f7d280128decc887017.png"
         alt=""/>
      </div>
<!--      <div class="text-wrapper_1 flex-col">-->
<!--        <span class="text_3"></span>-->
<!--      </div>-->
      <div v-for="i in count" :key="i">
        <div class="text-wrapper_req flex-col" :id="reqDiv(i)" v-show="i<count || reqShow"><span class="text_req" :id="req(i)"></span></div>
        <div class="text-wrapper_resp flex-col" :id="respDiv(i)" v-show="i<count  || respShow"><span class="text_resp" :id="resp(i)"></span></div>
      </div>

<!--      <div class="box_4 flex-row">-->
      <div class="box_4 flex-row">
        <img @click="reset"
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngbdc51b3677cf356afc464d8db891780e3325af128c784e53f75d7c45ed5034f4.png"
         alt=""/>
        <div v-if="onReco">
          <!-- 结束录音 -->
          <div @click="endRecorder()" class="endToEndIdentification_end_recorder_img">
            <div class='endToEndIdentification_end_recorder_img_back'></div>
          </div>
        </div>
        <div v-else>
          <div @click="startRecorder()" class="endToEndIdentification_start_recorder_img"></div>
        </div>
<!--        <span class="text_7">请输入您想问的问题</span>-->

<!--        <div class="box_5 flex-col"></div>-->
<!--        <div class="box_6 flex-col">-->
        <div class="box_6 flex-col">
          <span class="text_7">
<!--            <el-input id="input_content" class="input_content" type="text" v-model="content" placeholder="请输入您想问的问题" @keyup.enter="chatEvent"/>-->
            <el-input id="input_content" class="input_content" type="text" v-model="content" placeholder="请输入您想问的问题" @change="chatEvent"/>
            <el-button type="primary" @click="submitForm" :loading="submitLoading" class="button_submitForm" >
<!--              <i class="el-icon-devops" />-->
              提交
            </el-button>
          </span>
        </div>
      </div>
<!--      <img-->
<!--        class="image_6"-->
<!--        referrerpolicy="no-referrer"-->
<!--        src="./assets/img/SketchPng39e0145cb5f9aedbdc47ba7b97079bb91f0227f31b11f019bb74d1d676930079.png"-->
<!--       alt=""/>-->

      <div class="box_6 flex-col">
          <span class="text_7">
          </span>
      </div>

      <div class="text-wrapper_req_no_back flex-col"><span class="text_req"></span></div>
      <div class="text-wrapper_resp_no_back flex-col"><span class="text_resp"></span></div>

    </div>
  </div>
</template>
<script>
import Recorder from 'js-audio-recorder'
import { asrOffline } from '@/api/ApiASR'
import {ttsOffline} from "@/api/ApiTTS";

// import { Button as el-button } from 'element-ui'

const recorder = new Recorder({
  sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
  sampleRate: 16000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
  numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
  compiling: true
})
const host= 'https://api.wiseai.chat/api-aicc'
const urlChat= '/v1/chat'

// 全局承接流式 chunk 块
// let chunks = []
// let AudioContext = window.AudioContext || window.webkitAudioContext;
// let chunk_index = 0
// let palyIndex = 0
// let reciveOver = false


// 定义新的流式播放服务
let _audioSrcNodes = []
const _audioCtx = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'interactive' });
let _playStartedAt = 0
let _totalTimeScheduled = 0

// function _reset(){
//   _playStartedAt = 0
//   _totalTimeScheduled = 0
//   _audioSrcNodes = []
// }

export default {
  // components: {
  //   el-button
  // },
  chat:{ url: host + urlChat, method:"post" },
  created () {
    document.title = '中宝AI药师'
  },
  data() {
    return {
      textTitle:'中宝AI药师',
      data: {},
      content:"",
      count:1,
      submitLoading:false,
      pharm_url:"https://ai.zb-tech.com",
      reqShow:false,
      respShow:false,
      onReco: false,
      asrResult: "",
    };
  },
  methods: {
    reset(){
      this.count=1
    },
    share(){
      let clipboard = new this.clipboard(".thumbnail_5")
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制链接成功!",
          type: "success",
          duration: 2000,
        })
        //清除选中
        e.clearSelection();
        //释放内存，以防重复复制
        clipboard.destroy();
      })
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message({
          message: "复制链接失败!",
          type: "error",
          duration: 2000,
        });
        //清除选中
        e.clearSelection();
        //释放内存，以防重复复制
        clipboard.destroy();
      })
    },
    reqDiv(i){
      return `reqDiv_${i}`
    },
    respDiv(i){
      return `respDiv_${i}`
    },
    req(i){
      return `req_${i}`
    },
    resp(i){
      return `resp_${i}`
    },
    // chatEvent(event){
    chatEvent(value){
      // console.log(event.target)
      console.log("chatEvent:"+value)
      // console.log(this.content)

      this.submitForm()
    },
    submitForm(){
      this.submitLoading=true
      // console.log("submitForm")
      // console.log(this.content)
      // console.log("this.count")
      // console.log(this.count)
      // let max=5
      let reqDiv=document.getElementById("reqDiv_"+this.count)
      // let respDiv=document.getElementById("respDiv_"+this.count)
      let req=document.getElementById("req_"+this.count)
      let resp=document.getElementById("resp_"+this.count)
      // console.log("req_"+this.count)
      // console.log("resp_"+this.count)
      // console.log("req")
      // console.log(req)
      // console.log("resp")
      // console.log(resp)
      // for(let i=0; i<max; i++){
      //   req[i]=document.getElementById("req_"+(i+1).toString())
      //   resp[i]=document.getElementById("resp_"+(i+1).toString())
      // }

      let input_content=document.getElementById("input_content")
      input_content.select()
      // let reqText=req.innerHTML;

      let messages=[{"role":"user","content":this.content}]
      let reqStyleObject = null
      let respStyleObject = null
      let reqWidth=20
      let respWidth=20

      // if(reqText_2.length>0){
      //   req_1.innerHTML=req_2.innerHTML
      //   styleObject=req_1.currentStyle != null ? req_1.currentStyle : getComputedStyle(req_1, false)
      //   req_1.style.width=(req_1.innerHTML.length*styleObject.fontSize.replace("px","")).toString()+"px"
      //   resp_1.innerHTML=resp_2.innerHTML
      //   styleObject=resp_1.currentStyle != null ? resp_1.currentStyle : getComputedStyle(resp_1, false)
      //   resp_1.style.width=(resp_1.innerHTML.length*styleObject.fontSize.replace("px","")).toString()+"px"
      //   resp_1.style.height=(resp_1.innerHTML.length/respWidth*styleObject.fontSize.replace("px","")).toString()+"px"
      //   messages=[{"role":"user","content":req_1.innerHTML},{"role":"assistant","content":resp_1.innerHTML},{"role":"user","content":req_2.innerHTML}]
      // }
      let reqText=""
      let respText=""
      messages=[]
      // console.log("this.count")
      // console.log(this.count)
      if(this.count>1){
        for(let i=1;i<this.count;i++) {
          req = document.getElementById("req_" + i)
          resp = document.getElementById("resp_" + i)
          reqText = req.innerHTML
          respText = resp.innerHTML
          messages.push({"role": "user", "content": reqText})
          messages.push({"role": "assistant", "content": respText})
        }
      }
      reqDiv = document.getElementById("reqDiv_" + this.count.toString())
      // let respDiv = document.getElementById("respDiv_" + this.count.toString())
      req = document.getElementById("req_" + this.count.toString())
      resp = document.getElementById("resp_" + this.count.toString())
      messages.push({"role":"user","content":this.content})
      // console.log(messages)
      req.innerHTML=this.content
      req.width="300px"
      // req.width="200px"
      // req.style.width="100px"
      // reqStyleObject=(req.currentStyle != null) ? req.currentStyle : getComputedStyle(req, "false")
      reqStyleObject=getComputedStyle(req, "false")
      // reqStyleObject.width="100px"
      // req.style.width=(req.innerHTML.length*reqStyleObject.fontSize).toString()
      // req.style.width=req.innerHTML.length*req.style.fontSize.toString()+"px"
      // console.log("req")
      // console.log(req)
      // console.log("req.style")
      // console.log(req.style)
      // console.log("req.style.width")
      // console.log(req.style.width)
      //
      // console.log("reqDiv.style")
      // console.log(reqDiv.style)
      // console.log("reqStyleObject")
      // console.log(reqStyleObject)

      reqDiv.style.hidden=false
      this.reqShow=true
      // req=document.getElementById("req_"+this.count.toString())
      reqStyleObject=getComputedStyle(req, "false")
      let reqLen=req.innerHTML.length<reqWidth?req.innerHTML.length:reqWidth
      let reqHeight=Math.ceil(req.innerHTML.length/reqWidth)
      let reqFontHeight=parseInt(reqStyleObject.fontSize.replace("px",""))+5
      req.style.width=(reqLen*reqStyleObject.fontSize.replace("px","")).toString()+"px"
      req.style.height=(reqHeight*reqFontHeight).toString()+"px"

      // resp.innerHTML=""
      // this.axios.post(host+"/v1/chat", this.qs.stringify({

      this.axios.post(host+urlChat, {
        messages: messages,
        session_id: "abc125",
        temperature: 0,
        doc_id: "",
        follow_up_enabled: "N",
        follow_up_number:1,
        stream_enabled: "N"
        }, {
            headers: {
              'Authorization': 'Bearer 2a789f52-5a03-4fd5-a2ed-db55dc7d9348',
              'Content-Type': 'application/json;charset=UTF-8'
            }
        }).then(response=> {
          this.respShow=true

        // console.log(response)
          // console.log(response.data)
          // console.log(response.data.result.response_content)
          // let reqDiv=document.getElementById("reqDiv_"+this.count.toString())
          let respDiv=document.getElementById("respDiv_"+this.count.toString())
          let resp=document.getElementById("resp_"+this.count.toString())
          resp.innerHTML=response.data.result.response_content
          respDiv.style.hidden=false
          // let reqStyleObject
          // let respStyleObject
          // reqStyleObject=req.currentStyle != null ? req.currentStyle : getComputedStyle(req, "false")
          respStyleObject=getComputedStyle(resp, "false")
          // console.log("resp.innerHTML.length")
          // console.log(resp.innerHTML.length)
          // console.log("resp.style.fontSize")
          // console.log(resp.style.fontSize)
          // console.log("respStyleObject.fontSize")
          // console.log(respStyleObject.fontSize)
          let respLen=resp.innerHTML.length<respWidth?resp.innerHTML.length:respWidth
          // console.log("resp.innerHTML.length")
          // console.log(resp.innerHTML.length)
          // console.log("respLen")
          // console.log(respLen)
          // console.log("resp.innerHTML.length/respWidth")
          // console.log(resp.innerHTML.length/respWidth)
          resp.style.width=(respLen*respStyleObject.fontSize.replace("px","")).toString()+"px"
          let respHeight=Math.ceil(resp.innerHTML.length/respWidth)
          // console.log("respHeight")
          // console.log(respHeight)
          let respFontHeight=parseInt(respStyleObject.fontSize.replace("px",""))+5
          resp.style.height=(respHeight*respFontHeight).toString()+"px"
          this.data = response.data
          this.EndToEndSynthesis()
          this.count++
          this.reqShow=false
          this.respShow=false
          this.submitLoading=false
      }).catch(error => {
        console.error(error);
      })
    },

    // 状态变量重置
    resetStatus(){
      // this.streamingContinueStatus = true
      // this.streamingOnInit = true
      // this.streamingStopStatus = false
      //
      // this.endToEndContinueStatus = true
      // this.endToEndOnInit = true
      // this.endToEndStopStatus = false
    },

    // 开始录音
    startRecorder(){
      this.onReco = true
      // recorder.clear()
      recorder.start()
    },

    // 停止录音
    endRecorder(){
      recorder.stop()
      this.onReco = false
      // this.$nextTick(()=>{})
      // 音频导出成wav,然后上传到服务器
      const wavs = recorder.getWAVBlob()
      this.uploadFile(wavs)
    },

    // 上传文件
    async uploadFile(file){
      const formData = new FormData()
      formData.append('files', file)
      const result = await asrOffline(formData)
      console.log(result)
      console.log(result.data.result)
      if (result.data.code === 0) {
        this.asrResult = result.data.result
        // this.$nextTick(()=>{})
        // this.$message.success(result.data.message);
        this.content=result.data.result

        this.submitForm()
      } else {
        // this.$message.error(result.data.message);
      }
    },

    // 流式播放器
    _schedulePlaybackWav({wavData}) {
      var _that = this
      _audioCtx.decodeAudioData(wavData, audioBuffer => {
        const audioSrc = _audioCtx.createBufferSource()
        audioSrc.onended = () => {
          _audioSrcNodes.shift();
          if(_audioSrcNodes.length === 0){
            _that.resetStatus()
          }
        };
        _audioSrcNodes.push(audioSrc);
        let startDelay = 0;
        if (!_playStartedAt) {
          startDelay = 10 / 1000;
          _playStartedAt = _audioCtx.currentTime + startDelay;
        }
        audioSrc.buffer = audioBuffer;
        audioSrc.connect(_audioCtx.destination);

        const startAt = _playStartedAt + _totalTimeScheduled;
        audioSrc.start(startAt);

        _totalTimeScheduled+= audioBuffer.duration;

      })
    },

    // base64转换
    base64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding)
          .replace(/-/g, '+')
          .replace(/_/g, '/');

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },

    // 端到端合成
    async EndToEndSynthesis(){
      // this.endToEndSendStamp = Date.now()
      // this.endToEndOnInit = false
      // this.endToEndStopStatus = true

      // let ttsResult = await this.$http.post("/tts/offline", { text : this.content})
      let ttsResult = await ttsOffline(this.data.result.response_content)

      if (ttsResult.status == 200) {
        // this.endToEndAcceptStamp = Date.now()
        // this.endToEndStopStatus = false
        // this.endToEndContinueStatus = true
        // base转换二进制数
        console.log('res', ttsResult)
        let typedArray = this.base64ToUint8Array(ttsResult.data.result)
        // 播放音频
        this._schedulePlaybackWav({
          wavData: typedArray.buffer,
        })
      }
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />